import { MqSwitch } from '@fhs/ui';

import { ChallengeHomeCardDesktop } from './challenge-home-card-desktop';
import { ChallengeHomeCardMobile } from './challenge-home-card-mobile';
import { ChallengeHomeCardProps } from './types';

export * from './types';

export const ChallengeHomeCard = (props: ChallengeHomeCardProps) => {
  return (
    <MqSwitch
      $ltDesktop={() => <ChallengeHomeCardMobile {...props} />}
      $gteDesktop={() => <ChallengeHomeCardDesktop {...props} />}
    />
  );
};
